import type { ReactNode } from 'react'

export type SelectionBoxPreviewState = 'default' | 'selected'

export const SELECTION_BOX_PREVIEW_STATES: SelectionBoxPreviewState[] = [
  'default',
  'selected',
]

export const SELECTION_BOX_PREVIEW_STATE_LABELS: Record<
  SelectionBoxPreviewState,
  string
> = {
  default: 'Default',
  selected: 'Selected',
}

export type SelectionBoxProps = {
  title: string
  description?: ReactNode
  /** When false, hides the description even if provided. Defaults to true when description is set. */
  showDescription?: boolean
  /** Shows the trailing “Selected” label when selected. Defaults to true. */
  showSelectIndicator?: boolean
  selected?: boolean
  disabled?: boolean
  /** Value used when rendered inside SelectionBoxGroup. */
  value?: string
  darkMode?: boolean
  className?: string
  onSelect?: () => void
  /** Static visual state for the design-system showcase only. */
  previewState?: SelectionBoxPreviewState
}

export type SelectionBoxOption = {
  value: string
  title: string
  description?: string
  disabled?: boolean
}

export type SelectionBoxGroupProps = {
  name?: string
  value?: string
  defaultValue?: string
  label?: ReactNode
  options?: SelectionBoxOption[]
  disabled?: boolean
  darkMode?: boolean
  className?: string
  onChange?: (value: string) => void
  children?: ReactNode
}
